require('./RAAmountInputWithLabels.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { AmountInput } = require('commonsComponents/amountInput');
const { getLanguage } = require('core/i18n').i18n;

class RAAmountInputWithLabels extends React.Component {
    buildLabels() {
        const { minLabel, maxLabel, unit } = this.props;

        const leftLabel = minLabel ? (
            <div className="ra-amount-input-with-labels__left-label">
                {minLabel} {unit}
            </div>
        ) : null;
        const rightLabel = maxLabel ? (
            <div className="ra-amount-input-with-labels__right-label">
                {maxLabel} {unit}
            </div>
        ) : null;

        return rightLabel || leftLabel ? (
            <div className="ra-amount-input-with-labels__labels no-print-out">
                {leftLabel}
                {rightLabel}
            </div>
        ) : null;
    }

    buildErrors() {
        const { error, errorMsg } = this.props;
        if (!error) {
            return null;
        }

        return (
            <div className="ra-amount-input-with-labels__error">{errorMsg}</div>
        );
    }

    render() {
        const { unit } = this.props;
        return (
            <div className="ra-amount-input-with-labels">
                <div className="ra-amount-input-with-labels__input">
                    <AmountInput
                        {...this.props}
                        errorMsg=""
                        language={getLanguage()}
                    />
                    <span className="ra-amount-input-with-labels__unit">
                        {unit}
                    </span>
                </div>
                {this.buildLabels()}
                {this.buildErrors()}
            </div>
        );
    }
}

RAAmountInputWithLabels.propTypes = {
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    minLabel: PropTypes.string,
    maxLabel: PropTypes.string,
    unit: PropTypes.string,
};

module.exports = RAAmountInputWithLabels;
